import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const inputFieldDisplayTextValidator = Validator.object(fieldDisplayTextValidatorSchema);
